var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useThemeUI } from "theme-ui";

var useTheme = function useTheme() {
  var themeUI = useThemeUI();
  return __assign(__assign({}, themeUI), {
    theme: themeUI.theme
  });
};

export default useTheme;